import * as types from './types';

const setSearchPage = (page) => ({
  type: types.SET_SEARCH_PAGE,
  data: { page },
});

const setSearchQuery = (query) => ({
  type: types.SET_SEARCH_QUERY,
  data: { query },
});

const setSearchFilter = (name, values) => ({
  type: types.SET_SEARCH_FILTER,
  data: { name, values },
});

const setSearchSort = (sort) => ({
  type: types.SET_SEARCH_SORT,
  data: { sort },
});

const setSearchStatus = (status) => {
  return {
    type: types.SET_SEARCH_STATUS,
    data: { status },
  };
};

const setSearchSummary = (searchSummary) => ({
  type: types.SET_SEARCH_SUMMARY,
  data: { searchSummary },
});

export {
  setSearchFilter,
  setSearchStatus,
  setSearchQuery,
  setSearchPage,
  setSearchSort,
  setSearchSummary,
};
